export class Factores {
    public Tabla: string;
    public factorId:number;
    public Pagina: number;
    public Buscar: string;
    public Tipo: string;


    constructor() {
        this.Pagina = 1;
        this.Tabla = '';
        this.Buscar = '';
        this.Tipo = '';
        this.factorId = 0;
    }
}
